'use client';

import dynamic from 'next/dynamic';
import type { PublicCourseWithMidTerm } from '@/server/services/course.service';

const CatalogClient = dynamic(
  () => import('@/components/enrollment/catalog-client').then((m) => m.CatalogClient),
  { ssr: false }
);

export function CatalogClientWrapper({
  initialCourses,
  initialHasMore = false,
  programSlug = null,
}: {
  initialCourses: PublicCourseWithMidTerm[];
  initialHasMore?: boolean;
  /** SSR-resolved active program. Threaded into the client query key so the
   *  list actually changes when the switcher moves (the cookie is invisible to
   *  a TanStack Query key). */
  programSlug?: string | null;
}) {
  return (
    <CatalogClient
      initialCourses={initialCourses}
      initialHasMore={initialHasMore}
      programSlug={programSlug}
    />
  );
}
